import { FC } from "react";
import { Trans } from "@lingui/macro";
import { ChevronTextSmall } from "src/icons/ChevronTextSmall";
import { Heading, Text } from "@otrium/atoms";
import { Box } from "@otrium/core";
import {
  StyledProductCarouselInfoText,
  StyledTitle,
  StyledLink,
} from "./ProductCarouselInfoText.styled";
import { sanitize } from "isomorphic-dompurify";

interface ProductCarouselInfoTextProps {
  linkHref?: string;
  subTitle?: string;
  title?: string;
  viewAllOnClick: () => void;
}

const ProductCarouselInfoText: FC<ProductCarouselInfoTextProps> = ({
  linkHref = "",
  subTitle = "",
  title = "",
  viewAllOnClick,
}) => {
  return (
    <StyledProductCarouselInfoText>
      <Box display={["none", "none", "block", "block"]}>
        <StyledTitle
          as="h3"
          dangerouslySetInnerHTML={{
            __html: sanitize(title),
          }}
        />
        <Text
          lineHeight="24px"
          color={"tone.black"}
          marginBottom={[3]}
          as="p"
          dangerouslySetInnerHTML={{
            __html: sanitize(subTitle),
          }}
        />
        {linkHref ? (
          <StyledLink href={linkHref} hasUnderline onClick={viewAllOnClick}>
            <Trans>View all</Trans>
          </StyledLink>
        ) : (
          <StyledLink asLink hasUnderline onClick={viewAllOnClick}>
            <Trans>View all</Trans>
          </StyledLink>
        )}
      </Box>

      <Box display={["block", "block", "none", "none"]}>
        {linkHref ? (
          <StyledLink
            href={linkHref}
            icon={
              <ChevronTextSmall
                style={{
                  margin: "0",
                }}
                role="presentation"
              />
            }
          >
            <Heading
              variant="h3"
              as="h3"
              dangerouslySetInnerHTML={{
                __html: sanitize(title),
              }}
            />
          </StyledLink>
        ) : (
          <StyledLink
            asLink
            icon={
              <ChevronTextSmall
                style={{
                  margin: "0",
                }}
                role="presentation"
              />
            }
            onClick={viewAllOnClick}
          >
            <Heading
              variant="h3"
              as="h3"
              dangerouslySetInnerHTML={{
                __html: sanitize(title),
              }}
            />
          </StyledLink>
        )}
        {subTitle && (
          <Text
            lineHeight="24px"
            color={"tone.black"}
            marginBottom={[3]}
            as="p"
            dangerouslySetInnerHTML={{
              __html: sanitize(subTitle),
            }}
          />
        )}
      </Box>
    </StyledProductCarouselInfoText>
  );
};

export default ProductCarouselInfoText;
